import { logger } from "./logger";
// Player profile + badge tracking utilities (backend-backed)
// SECURITY NOTE: localStorage stores only the active player nickname (non-PII).
// Actual profile/badge state is in MongoDB on backend. Static analyzers may flag
// this as "sensitive data in localStorage" — false positive for this app.
const ACTIVE_KEY = "alba_active_player";
const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function getActivePlayer() {
  try { return localStorage.getItem(ACTIVE_KEY) || ""; } catch (err) { logger.debug("playerProfile getActive failed", err); return ""; }
}

export function setActivePlayer(name) {
  try { localStorage.setItem(ACTIVE_KEY, (name || "").trim()); } catch (err) { logger.debug("playerProfile setActive failed", err); }
}

async function postProfileEvent(path, gameId) {
  const player = getActivePlayer();
  if (!player) return null;
  try {
    const res = await fetch(`${API}/profile/${path}`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ player_name: player, game_id: gameId }),
    });
    if (!res.ok) return null;
    return await res.json();
  } catch (e) { return null; }
}

export function recordGamePlayed(gameId) {
  return postProfileEvent("play", gameId);
}

export function recordGameWon(gameId) {
  return postProfileEvent("win", gameId);
}

export async function fetchProfile(playerName) {
  const name = (playerName || getActivePlayer()).trim();
  if (!name) return null;
  try {
    const res = await fetch(`${API}/profile/${encodeURIComponent(name)}`);
    if (!res.ok) return null;
    return await res.json();
  } catch (err) { logger.debug("playerProfile fetchProfile failed", err); return null; }
}

export async function fetchBadgeCatalog() {
  try {
    const res = await fetch(`${API}/profile/badges/catalog`);
    if (!res.ok) return null;
    return await res.json();
  } catch (err) { logger.debug("playerProfile fetchCatalog failed", err); return null; }
}

// Local visual definitions for game badges (id -> {name, icon})
export const GAME_BADGE_META = {
  classic: { name: "X O X", icon: "❌⭕" },
  gomoku: { name: "Gomoku", icon: "⚫⚪" },
  sos: { name: "SOS", icon: "🆘" },
  memory: { name: "Memory Card", icon: "🎴" },
  maze: { name: "Labirin Ajaib", icon: "🌟" },
  whack: { name: "Pukul Jawaban", icon: "💥" },
  snake: { name: "Ular Kata", icon: "🐍" },
  block: { name: "Balok Pintar", icon: "🧩" },
  simon: { name: "Lampu Ajaib", icon: "💡" },
  snakeladder: { name: "Ular Tangga", icon: "🎲" },
  balon: { name: "Balon Teman", icon: "🎈" },
  dongbola: { name: "Dorong Bola", icon: "⚽" },
  masak: { name: "Masak Bareng", icon: "🍳" },
  tebak: { name: "Tebak Gambar", icon: "🔍" },
  menara: { name: "Menara Balok", icon: "🏗️" },
  tangkap: { name: "Tangkap Bintang", icon: "⭐" },
  puzzle: { name: "Puzzle Potong", icon: "🧩" },
  lomba: { name: "Lomba Lari", icon: "🏃" },
  mewarnai: { name: "Mewarnai", icon: "🎨" },
  hitung: { name: "Game Hitung", icon: "🧮" },
  musik: { name: "Game Musik", icon: "🎵" },
  balap: { name: "Game Balap", icon: "🏎️" },
  lempar: { name: "Lempar Bola", icon: "🎯" },
  suara: { name: "Tebak Suara", icon: "🔊" },
  warna: { name: "Cocok Warna", icon: "🌈" },
  huruf: { name: "Belajar Huruf", icon: "🔤" },
  haribulan: { name: "Hari & Bulan", icon: "📅" },
  bendera: { name: "Tebak Bendera", icon: "🌍" },
  sudoku: { name: "Sudoku Anak", icon: "🧩" },
  pola: { name: "Tebak Pola", icon: "🔢" },
  jam: { name: "Belajar Jam", icon: "⏰" },
  cerita: { name: "Cerita Pilih", icon: "📖" },
  provinsi: { name: "Provinsi", icon: "🇮🇩" },
  pahlawan: { name: "Pahlawan", icon: "🦸" },
};
